export const CHANGE_STEP = 'CHANGE_STEP';
export const SETUP_STATES = [
    'get-started',
    'setup',
    'verify',
    'success'
];